export default __webpack_public_path__ + "static/mirai-magical-school-winter-festival_03-e9eabb792019ebe66fa4c6a66a9d8e80.jpg";